module.exports = __webpack_public_path__ + "static/media/South_Aegean.a9a72958.jpg";